window.addEventListener('DOMContentLoaded',()=>{
    // slider handle
    let sliders = document.querySelectorAll('.hero_slider');
    
    if(sliders){
        sliders.forEach(slider =>{
            let slides = slider.querySelectorAll('.slide');
            let dots = slider.querySelectorAll('.dots')
            let cur_index = 0;
            let interval_time = 12000;
            function activate(i, dots, slides){
                //remove old active class
                dots.forEach(dot =>{dot.classList.remove('active')});
                slides.forEach(slide =>{slide.classList.remove('active')});
    
                //add current active class
                dots[i].classList.add('active');
                slides[i].classList.add('active');

                let title = slider.querySelector(`#slide-${i} .title`);
                let copy = slider.querySelector(`#slide-${i} .copy-wrapper`)
                resetAnimation(title)
                resetAnimation(copy)
            }
    
            function runSlide(){
                if(cur_index >= dots.length){
                    cur_index = 0;
                }
                activate(cur_index++,dots,slides);
            }
            function resetAnimation(item){
                if(item){
                    item.classList.remove('aos-animate');
                    setTimeout(function() {
                        item.classList.add('aos-animate');
                    }, 500);
                }
            }
            let interval_object = setInterval(runSlide, interval_time);
            
            dots.forEach(dot =>{
                dot.addEventListener('click', e=>{
                    let title = slider.querySelector(`#slide-${e.target.dataset.index} .title`);
                    let copy = slider.querySelector(`#slide-${e.target.dataset.index} .copy-wrapper`)
                    resetAnimation(title)
                    resetAnimation(copy)

                    clearInterval(interval_object);
                    activate(e.target.dataset.index,dots,slides);
                    cur_index = e.target.dataset.index;
                    interval_object = setInterval(runSlide,interval_time);
                })
            })
        })
    }
})